// client/src/components/ui/ProgressSteps.js
export default function ProgressSteps({ steps, currentStep }) {
  const currentIndex = steps.findIndex((s) => s.id === currentStep);

  return (
    <div className="max-w-md mx-auto mb-8 px-4">
      <div className="flex items-center justify-between">
        {steps.map((step, i) => {
          const isCompleted = i < currentIndex;
          const isCurrent = step.id === currentStep;

          return (
            <div key={step.id} className="flex items-center flex-1 last:flex-none">
              {/* Step circle + label */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all ${
                    isCompleted
                      ? 'bg-gold text-royal-900'
                      : isCurrent
                        ? 'bg-gold/20 border-2 border-gold text-gold'
                        : 'bg-royal-900 dark:bg-royal-800 border border-royal-700 dark:border-royal-600 text-royal-100'
                  }`}
                >
                  {isCompleted ? (
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    i + 1
                  )}
                </div>
                <span
                  className={`text-xs mt-1.5 whitespace-nowrap ${
                    isCompleted
                      ? 'text-gold-dark dark:text-gold'
                      : isCurrent
                        ? 'text-gold-dark dark:text-royal-200 font-medium'
                        : 'text-royal-500 dark:text-royal-200'
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {i < steps.length - 1 && (
                <div
                  className={`flex-1 h-0.5 mx-2 mb-5 transition-all ${
                    i < currentIndex ? 'bg-gold' : 'bg-royal-400 dark:bg-royal-700'
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}